"use strict";const normalizeUrl=require("normalize-url");module.exports=(a,b)=>a===b||normalizeUrl(a)===normalizeUrl(b);